<template>
  <v-row class="ma-0">
    <v-card flat tile width="100%" height="100%">
      <v-card-title>{{ $translate('CONFIRMATION') }}</v-card-title>
      <v-card-text v-html="confirmationMessage"></v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="onReject"
          color="secondary"
          class="text-capitalize secondary-font-color"
          >{{ $translate('CANCEL') }}</v-btn
        >
        <v-btn
          @click="onConfirmBtnClick"
          color="secondary"
          class="text-capitalize secondary-font-color"
          >{{ $translate('CONFIRM') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import UserParentChildRelations from '@/objects/UserParentChildRelations';
import utility from '@/shared/utility';
export default {
  name: 'ConfirmUserRelationAsChild',
  computed: {
    confirmationMessage() {
      return utility.sprintf(
        this.$translate('CONFIRMATION_MESSAGE'),
        this.$route.query.ParentUserName
      );
    },
  },
  methods: {
    onConfirmBtnClick() {
      this.confirmUserRelationAsChild();
    },
    async confirmUserRelationAsChild() {
      let relationObj = new UserParentChildRelations();
      try {
        await relationObj.confirmUserRelationAsChild(this.$route);
        window.EventBus.fire('request-accepted');
        this.onClose();
      } catch (error) {
        console.log('ERROR', error);
      }
    },
    onReject() {
      this.onClose();
    },
    onClose() {
      this.$emit('triggerPopup', { toggle: false, component: 'Login' });
      this.$emit('close');
    },
  },
};
</script>
<style scoped lang="scss"></style>
